import type { FC } from "react";

import type { StoreLocatorFilterCategory, StoreLocatorFilterItem } from "@locators/components/shared/types";

import { ChevronDownIcon } from "@jti/brand-icons/chevron-down";
import { ChevronUpIcon } from "@jti/brand-icons/chevron-up";

import { StoreLocatorFilterProductFlavoursCategory } from "./categories/StoreLocatorFilterProductFlavoursCategory";

import { StoreLocatorFilterCategoryItem } from "./StoreLocatorFilterCategoryItem";

import styles from "./StoreLocatorFilterCategory.module.scss";

type StoreLocatorFilterCategorySectionProps = {
  filterCategory: StoreLocatorFilterCategory;
  openCategories: string[];
  isProductFlavoursLYOFilterEnabled?: boolean;
  changeFilters?: (category: string, filter: StoreLocatorFilterItem) => void;
  checkFiltersStatus?: (category: string, filerKey: string) => boolean;
  handleCategoryClick: () => void;
};

const PRODUCT_FLAVOURS_CATEGORY = "ProductFlavours";

export const StoreLocatorFilterCategorySection: FC<StoreLocatorFilterCategorySectionProps> = ({
  filterCategory,
  openCategories,
  isProductFlavoursLYOFilterEnabled,
  handleCategoryClick,
  changeFilters,
  checkFiltersStatus,
}) => {
  const isOpenCategory = openCategories.includes(filterCategory.key);
  return (
    <div className={styles.filtersCategory} key={filterCategory.name} data-testid="filterCategoryContainer">
      <div className={styles.filtersCategoryContainer} onClick={handleCategoryClick}>
        <h4 className={styles.filtersCategoryTitle} data-testid="filterCategoryTitle">
          {filterCategory.name}
        </h4>
        <div className={styles.icons}>
          {isOpenCategory ? <ChevronUpIcon className={styles.icon} /> : <ChevronDownIcon className={styles.icon} />}
        </div>
      </div>
      {isOpenCategory && (
        <div className={styles.filtersCategoryItems} data-testid="filterCategoryItemsContainer">
          {filterCategory.key === PRODUCT_FLAVOURS_CATEGORY ? (
            <StoreLocatorFilterProductFlavoursCategory
              isProductFlavoursLYOFilterEnabled={isProductFlavoursLYOFilterEnabled}
              filterCategory={filterCategory}
              changeFilters={changeFilters}
              checkFiltersStatus={checkFiltersStatus}
            />
          ) : (
            filterCategory.filters.map((filter) => (
              <StoreLocatorFilterCategoryItem
                filter={filter}
                onChange={() => {
                  changeFilters?.(filterCategory.key, filter);
                }}
                isChecked={checkFiltersStatus?.(filterCategory.key, filter.key) ?? false}
                filterCategory={filterCategory.key}
                key={filter.key}
              />
            ))
          )}
        </div>
      )}
    </div>
  );
};
